<mat-slide-toggle
  hideIcon
  [checked]="checkedInternal"
  [disabled]="disabled"
  [labelPosition]="labelPosition"
  (change)="updateCheckedState($event)">
  <slot></slot>
</mat-slide-toggle>
